export const uk = {
    perWeek: 'в неделю'
};
